import { i18n } from '@/plugins/i18n'
import { toTypedSchema } from '@vee-validate/zod'
import { useField, useForm } from 'vee-validate'
import { z } from 'zod'

export class SignInForm {
  static getSignInForm() {
    const validationSchema = toTypedSchema(
      z.object({
        userEmail: z.string().email({ message: i18n.t('forms.errorMessages.email') }),
        userLogin: z.string().min(1, { message: i18n.t('forms.errorMessages.required') }),
        stayLoggedIn: z.boolean().optional(),
      }),
    )

    const { errors, handleSubmit, isSubmitting, meta } = useForm({
      validationSchema: validationSchema,
    })
    const form = {
      userEmail: useField<string>('userEmail', '', { validateOnValueUpdate: false }),
      userLogin: useField<string>('userLogin', '', { validateOnValueUpdate: false }),
      stayLoggedIn: useField<boolean>('stayLoggedIn', undefined, { validateOnValueUpdate: false }),
    }
    return { form, errors, handleSubmit, isSubmitting, meta }
  }
}
